import { useState } from "react";
import HomepageFooter from "@/components/homepage/HomepageFooter";
import HomepageLeadModal from "@/components/homepage/HomepageLeadModal";
import HomepageStickyCta from "@/components/homepage/HomepageStickyCta";
import Navbar from "@/components/homepage/Navbar";
import InviteAsSpeakerHero from "@/components/invite-as-speaker/Hero";
import InviteForm from "@/components/invite-as-speaker/InviteForm";
import WhoThisIsFor from "@/components/invite-as-speaker/WhoThisIsFor";
import WhyInvite from "@/components/invite-as-speaker/WhyInvite";
import { FORM_CONFIGS } from "@/config/forms";
import InviteSection from "@/components/homepage/InviteSection";

const InviteAsSpeaker = () => {
  const [leadModal, setLeadModal] = useState<{ open: boolean; email: string }>({
    open: false,
    email: "",
  });

  const openLeadModal = (email: string) => {
    setLeadModal({ open: true, email });
  };

  const closeLeadModal = () => {
    setLeadModal({ open: false, email: "" });
  };

  return (
    <main
      className="flex min-h-svh w-full flex-col bg-black pb-24 text-white max-md:pb-[calc(5rem+env(safe-area-inset-bottom,0px))]"
      style={{ fontFamily: "var(--font-fira)" }}
    >
      <Navbar />
      <InviteAsSpeakerHero />
      <WhyInvite />
      <InviteSection />
      <WhoThisIsFor />
      <InviteForm />
      <HomepageFooter onEmailContinue={openLeadModal} />
      <HomepageStickyCta
        heroSectionId="invite-as-speaker-hero"
        ctaSectionId="homepage-cta"
        marketingBasePath="/invite-as-speaker"
        onEmailContinue={openLeadModal}
      />
      <HomepageLeadModal
        open={leadModal.open}
        initialEmail={leadModal.email}
        onClose={closeLeadModal}
        formConfig={FORM_CONFIGS.vaibhav}
      />
    </main>
  );
};

export default InviteAsSpeaker;
